import moment from 'moment';

export const epochConverter = (time = '') => {
  let hours = '',
    minutes = '',
    seconds = '',
    milliseconds = '';

  const dateParts = time.split(':');
  hours = dateParts[0];
  minutes = dateParts[1];
  seconds = dateParts[2].split('.')[0];
  milliseconds = dateParts[2].split('.')[1];

  const finalDate = moment(0);

  finalDate.add(hours, 'hours');
  finalDate.add(minutes, 'minutes');
  finalDate.add(seconds, 'seconds');
  // finalDate.add(milliseconds, 'milliseconds');

  return Number(`${Date.parse(finalDate.toString()) / 1000}.${milliseconds}`);
};
